import React, { useEffect, useMemo, useRef, useState } from 'react'
import "./diagnosis.scss"
import { Form, Formik } from 'formik';
import { useSelector } from 'react-redux';
import { provisionalDxTitle } from '../../../utils/common-funtions/common';
import { visitUpdate } from '../../../service/api/visit';
import CustomModal from '../../common/modal/modal';
import { put, post, get, del } from "../../../utils/fetchAPI";
import { showSuccessToast } from '../../../utils/toaster-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faPenToSquare, faSquareCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import CreatableSearchSelect from '../../common/updated-input/createble-search-select/creatable-search-select';
import { ToolTip } from '../../common/tooltip/tooltip';

const Diagnosis = ({ visitDetails = {}, updateState }) => {
    const { selectedRole } = useSelector((state) => state.auth);
    const dxTitle = provisionalDxTitle(selectedRole);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [info, setInfo] = useState({});
    const [showAdd, setShowAdd] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [templateInfo, setTemplateInfo] = useState({})
    const [templateList, setTemplateList] = useState([])
    const [presentIllnessList, setPresentIllnessList] = useState([])
    const timeoutIdRef = useRef(null)
    const [showTemplates, setShowTemplates] = useState(false)
    const [showPresentIllness, setShowPresentIllness] = useState(false)
    const [showPresenetDelete, setShowPresenetDelete] = useState(false)
    const [tplSearch, setTplSearch] = useState({ provisional: "", differential: "" })

    useEffect(() => {
        if (visitDetails?.doctor) {
            getProvisionalDxList(visitDetails?.doctor)
            getDifferentialDxList(visitDetails?.doctor)
        }
    }, [visitDetails?.doctor])

    // The lists below are shared with the CreatableSearchSelect typeaheads, which refetch
    // them narrowed by whatever the doctor typed. Reload them unfiltered so the manager
    // always opens on the full set.
    const openTemplateManager = () => {
        setTplSearch({ provisional: "", differential: "" })
        if (visitDetails?.doctor) {
            getProvisionalDxList(visitDetails?.doctor)
            getDifferentialDxList(visitDetails?.doctor)
        }
        setShowTemplates(true)
    }

    // Provisional Dx
    const setProvisionalDxFun = (event) => {
        event.preventDefault()
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { getProvisionalDxList(visitDetails?.doctor, event?.target?.value) }, 800)
    }
    const handleProvisionalDxAddSubmit = (value) => {
        let data = { ...info }
        let updated = ((data?.provisionalDx || "") + (data?.provisionalDx ? "\n" : "") + (value?.provisionalDx || ""))
        updateDiagnosis({ provisionalDxId: value?._id, provisionalDx: updated, differentialDx: data?.differentialDx })
        showSuccessToast("Added")
    }
    const handleCreateProvisionalDx = (value) => {
        let data = { ...info }
        let updated = ((data?.provisionalDx || "") + (data?.provisionalDx ? "\n" : "") + (value || ""))
        updateDiagnosis({ provisionalDx: updated, differentialDx: data?.differentialDx })
        createNewProvisionalDx(value)
    }

    // Differential Dx
    const setDifferentialDxOptionFun = (event) => {
        event.preventDefault()
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { getDifferentialDxList(visitDetails?.doctor, event?.target?.value) }, 500)
    }
    const handleDifferentialDxAddSubmit = (value) => {
        let data = { ...info }
        let updated = ((data?.differentialDx || "") + (data?.differentialDx ? "\n" : "") + (value?.differentialDx || ""))
        updateDiagnosis({ differentialDxId: value?._id, provisionalDx: data?.provisionalDx, differentialDx: updated })
        showSuccessToast("Added")
    }
    const handleCreateDifferentialDx = (value) => {
        let data = { ...info }
        let updated = ((data?.differentialDx || "") + (data?.differentialDx ? "\n" : "") + (value || ""))
        updateDiagnosis({ provisionalDx: data?.provisionalDx, differentialDx: updated })
        createDifferentialDxTemplate(value)
    }

    const setInfoFun = (key, value, submit = false) => {
        let temp = { ...info, [key]: value };
        setInfo(temp);
        if (submit) { onSubmit(temp) }
    };

    const onSubmit = async (values) => { updateDiagnosis(values) };

    function updateDiagnosis(values) {
        setIsSubmitting(true)
        visitUpdate(values, visitDetails?._id)
            .then((res) => {
                if (res?.status == 200) { setIsSubmitting(false); updateState(res.data) }
            })
            .catch(() => { setIsSubmitting(false) });
    }

    const handleKeyDown = (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key === 's') {
            event.preventDefault();
            updateDiagnosis({ provisionalDx: info?.provisionalDx, differentialDx: info?.differentialDx })
        }
    }
    useEffect(() => {
        if (info) document.addEventListener('keydown', handleKeyDown);
        return () => { document.removeEventListener('keydown', handleKeyDown) };
    }, [info]);

    const createNewProvisionalDx = async (value = info?.provisionalDx) => {
        await post(`/doctor/provisionalDx`, { provisionalDx: value })
            .then((res) => { if (res?.status == 200) { getProvisionalDxList(visitDetails?.doctor); showSuccessToast("Saved as template") } })
            .catch(() => {});
    }
    const createDifferentialDxTemplate = async (value = info?.differentialDx) => {
        await post(`/doctor/differentialDx`, { differentialDx: value })
            .then((res) => { if (res?.status == 200) { getDifferentialDxList(visitDetails?.doctor); showSuccessToast("Saved as template") } })
            .catch(() => {});
    }

    const getProvisionalDxList = async (doctorId, search = "") => {
        await get(`/doctor/provisionalDx/list/${doctorId}${search ? `?search=${search}` : ""}`)
            .then((res) => { if (res?.status == 200) setTemplateList(res?.data) })
            .catch(() => {});
    }
    const getDifferentialDxList = async (doctorId, search = "") => {
        await get(`/doctor/differentialDx/list/${doctorId}${search ? `?search=${search}` : ""}`)
            .then((res) => { if (res?.status == 200) setPresentIllnessList(res?.data) })
            .catch(() => {});
    }

    const updateTemplate = async (type) => {
        let { differentialDx, ...payload } = templateInfo
        await put(`/doctor/${type}/update`, payload)
            .then((res) => { if (res?.status == 200) { getProvisionalDxList(visitDetails?.doctor); setTemplateInfo({}); setShowAdd(false); showSuccessToast("Updated successfully") } })
            .catch(() => {});
    }
    const updateDifferentialDx = async () => {
        let { provisionalDx, ...payload } = templateInfo
        await put(`/doctor/differentialDx/update`, payload)
            .then((res) => { if (res?.status == 200) { getDifferentialDxList(visitDetails?.doctor); setTemplateInfo({}); setShowPresentIllness(false); showSuccessToast("Updated successfully") } })
            .catch(() => {});
    }
    const deleteTemplate = async (type, id) => {
        await del(`/doctor/${type}/delete/${id}`)
            .then((res) => { if (res?.status == 200) { getProvisionalDxList(visitDetails?.doctor); setTemplateInfo({}); setShowDelete(false); showSuccessToast("Deleted successfully") } })
            .catch(() => {});
    }
    const deleteDifferentialDx = async (id) => {
        await del(`/doctor/differentialDx/delete/${id}`)
            .then((res) => { if (res?.status == 200) { getDifferentialDxList(visitDetails?.doctor); setTemplateInfo({}); setShowPresenetDelete(false); showSuccessToast("Deleted successfully") } })
            .catch(() => {});
    }

    const filteredTemplateList = useMemo(() => {
        const q = tplSearch.provisional.trim().toLowerCase()
        if (!q) return templateList || []
        return (templateList || []).filter((t) => (t?.provisionalDx || "").toLowerCase().includes(q))
    }, [templateList, tplSearch.provisional])

    const filteredDifferentialDxList = useMemo(() => {
        const q = tplSearch.differential.trim().toLowerCase()
        if (!q) return presentIllnessList || []
        return (presentIllnessList || []).filter((t) => (t?.differentialDx || "").toLowerCase().includes(q))
    }, [presentIllnessList, tplSearch.differential])

    useMemo(() => {
        if (visitDetails) {
            setInfo({ provisionalDx: visitDetails?.provisionalDx || "", differentialDx: visitDetails?.differentialDx || "" });
        }
    }, [visitDetails])

    return (
        <div className="cc-wrap">

            {isSubmitting && (
                <div className="cc-saving-badge" aria-live="polite">
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    Saving…
                </div>
            )}

            {visitDetails && (
                <Formik initialValues={{}} onSubmit={onSubmit}>
                    {() => (
                        <Form className="cc-grid" encType="multipart/form-data" noValidate>

                            {/* ── Provisional Diagnosis ──────────────────── */}
                            <div className="cc-field">
                                <CreatableSearchSelect
                                    options={templateList}
                                    setOptionFun={setProvisionalDxFun}
                                    handleSubmit={handleProvisionalDxAddSubmit}
                                    handleCreate={handleCreateProvisionalDx}
                                />
                                <div className="cc-field__header">
                                    <span className="cc-field__label">{dxTitle}</span>
                                    <div className="cc-field__actions">
                                        <button type="button" className="cc-field__tpl-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => createNewProvisionalDx()}>
                                            Save as template
                                        </button>
                                        <button type="button" className="cc-field__gear-btn" title="Manage templates" onClick={openTemplateManager}>
                                            <FontAwesomeIcon icon={faGear} />
                                        </button>
                                    </div>
                                </div>
                                <textarea
                                    className="cc-field__textarea"
                                    rows={6}
                                    placeholder={dxTitle}
                                    value={info?.provisionalDx || ""}
                                    onChange={(e) => setInfoFun("provisionalDx", e.target.value)}
                                    onBlur={(e) => setInfoFun("provisionalDx", e.target.value, true)}
                                />
                            </div>

                            {/* ── Differential Diagnosis ─────────────────── */}
                            <div className="cc-field">
                                <CreatableSearchSelect
                                    options={presentIllnessList}
                                    setOptionFun={setDifferentialDxOptionFun}
                                    handleSubmit={handleDifferentialDxAddSubmit}
                                    handleCreate={handleCreateDifferentialDx}
                                />
                                <div className="cc-field__header">
                                    <span className="cc-field__label">Differential Diagnosis</span>
                                    <div className="cc-field__actions">
                                        <button type="button" className="cc-field__tpl-btn" onMouseDown={(e) => e.preventDefault()} onClick={() => createDifferentialDxTemplate()}>
                                            Save as template
                                        </button>
                                        <button type="button" className="cc-field__gear-btn" title="Manage templates" onClick={openTemplateManager}>
                                            <FontAwesomeIcon icon={faGear} />
                                        </button>
                                    </div>
                                </div>
                                <textarea
                                    className="cc-field__textarea"
                                    rows={6}
                                    placeholder="Differential Diagnosis"
                                    value={info?.differentialDx || ""}
                                    onChange={(e) => setInfoFun("differentialDx", e.target.value)}
                                    onBlur={(e) => setInfoFun("differentialDx", e.target.value, true)}
                                />
                            </div>

                        </Form>
                    )}
                </Formik>
            )}

            {/* ── Edit: Provisional Dx template ─────────────────────────────── */}
            <CustomModal size="md" show={showAdd} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Edit Template — {dxTitle}</p>
                    <textarea
                        className="cc-modal__textarea"
                        rows={4}
                        value={templateInfo?.provisionalDx || ""}
                        onChange={(e) => setTemplateInfo({ provisionalDx: e.target.value, provisionalDxId: templateInfo?.provisionalDxId, doctorId: visitDetails?.doctor })}
                        placeholder="Enter template content"
                    />
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--primary" onClick={() => updateTemplate("provisionalDx")}>Update</button>
                        <button className="cc-modal__btn" onClick={() => setShowAdd(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Delete: Provisional Dx template ───────────────────────────── */}
            <CustomModal size="sm" show={showDelete} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Delete Template</p>
                    <p className="cc-modal__text">Are you sure you want to delete this template?</p>
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--danger" onClick={() => deleteTemplate("provisionalDx", templateInfo?.provisionalDxId)}>Delete</button>
                        <button className="cc-modal__btn" onClick={() => setShowDelete(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Edit: Differential Dx template ────────────────────────────── */}
            <CustomModal size="md" show={showPresentIllness} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Edit Template — Differential Diagnosis</p>
                    <textarea
                        className="cc-modal__textarea"
                        rows={4}
                        value={templateInfo?.differentialDx || ""}
                        onChange={(e) => setTemplateInfo({ differentialDx: e.target.value, differentialDxId: templateInfo?.differentialDxId, doctorId: visitDetails?.doctor })}
                        placeholder="Enter template content"
                    />
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--primary" onClick={updateDifferentialDx}>Update</button>
                        <button className="cc-modal__btn" onClick={() => setShowPresentIllness(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Delete: Differential Dx template ──────────────────────────── */}
            <CustomModal size="sm" show={showPresenetDelete} isHeaderHide={true}>
                <div className="cc-modal">
                    <p className="cc-modal__title">Delete Template</p>
                    <p className="cc-modal__text">Are you sure you want to delete this template?</p>
                    <div className="cc-modal__footer">
                        <button className="cc-modal__btn cc-modal__btn--danger" onClick={() => deleteDifferentialDx(templateInfo?.differentialDxId)}>Delete</button>
                        <button className="cc-modal__btn" onClick={() => setShowPresenetDelete(false)}>Cancel</button>
                    </div>
                </div>
            </CustomModal>

            {/* ── Template Manager: Provisional + Differential ───────────────── */}
            <CustomModal size="xl" show={showTemplates} isHeaderHide={true}>
                <div className="cc-tpl-modal">
                    <div className="cc-tpl-modal__head">
                        <h2 className="cc-tpl-modal__title">Template Manager</h2>
                        <button className="cc-tpl-modal__close" onClick={() => setShowTemplates(false)}>Close</button>
                    </div>
                    <div className="cc-tpl-modal__body">

                        <div className="cc-tpl-col">
                            <div className="cc-tpl-col__head">
                                <h3 className="cc-tpl-col__title">{dxTitle}</h3>
                                <input
                                    type="text"
                                    className="cc-tpl-col__search"
                                    placeholder={`Search ${dxTitle.toLowerCase()} templates`}
                                    value={tplSearch.provisional}
                                    onChange={(e) => setTplSearch((s) => ({ ...s, provisional: e.target.value }))}
                                />
                            </div>
                            {filteredTemplateList?.length > 0 ? filteredTemplateList.map((item, index) => (
                                <div key={index} className="cc-tpl-row">
                                    <textarea className="cc-tpl-row__text" rows={2} disabled readOnly value={item?.provisionalDx || ""} />
                                    <div className="cc-tpl-row__actions">
                                        <ToolTip text="Use">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--use" onClick={() => handleProvisionalDxAddSubmit(item)}>
                                                <FontAwesomeIcon icon={faSquareCheck} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Edit">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--edit" onClick={() => { setTemplateInfo({ provisionalDx: item?.provisionalDx || "", provisionalDxId: item?._id, doctorId: visitDetails?.doctor }); setShowAdd(true); }}>
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Delete">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--del" onClick={() => { setTemplateInfo({ provisionalDxId: item?._id }); setShowDelete(true); }}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </ToolTip>
                                    </div>
                                </div>
                            )) : <p className="cc-tpl-col__empty">{tplSearch.provisional.trim() ? "No templates match your search." : "No templates yet."}</p>}
                        </div>

                        <div className="cc-tpl-col">
                            <div className="cc-tpl-col__head">
                                <h3 className="cc-tpl-col__title">Differential Diagnosis</h3>
                                <input
                                    type="text"
                                    className="cc-tpl-col__search"
                                    placeholder="Search differential diagnosis templates"
                                    value={tplSearch.differential}
                                    onChange={(e) => setTplSearch((s) => ({ ...s, differential: e.target.value }))}
                                />
                            </div>
                            {filteredDifferentialDxList?.length > 0 ? filteredDifferentialDxList.map((item, index) => (
                                <div key={index} className="cc-tpl-row">
                                    <textarea className="cc-tpl-row__text" rows={2} disabled readOnly value={item?.differentialDx || ""} />
                                    <div className="cc-tpl-row__actions">
                                        <ToolTip text="Use">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--use" onClick={() => handleDifferentialDxAddSubmit(item)}>
                                                <FontAwesomeIcon icon={faSquareCheck} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Edit">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--edit" onClick={() => { setTemplateInfo({ differentialDx: item?.differentialDx || "", differentialDxId: item?._id, doctorId: visitDetails?.doctor }); setShowPresentIllness(true); }}>
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </button>
                                        </ToolTip>
                                        <ToolTip text="Delete">
                                            <button className="cc-tpl-row__btn cc-tpl-row__btn--del" onClick={() => { setTemplateInfo({ differentialDxId: item?._id }); setShowPresenetDelete(true); }}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </ToolTip>
                                    </div>
                                </div>
                            )) : <p className="cc-tpl-col__empty">{tplSearch.differential.trim() ? "No templates match your search." : "No templates yet."}</p>}
                        </div>

                    </div>
                </div>
            </CustomModal>

        </div>
    )
}

export default Diagnosis
